module.exports = __webpack_public_path__ + "img/champion-name-bg.90dde373.png";